import { useQuery } from '@tanstack/react-query';

import { apiFetch } from '@/api/client';

export interface Recommendation {
  id: number;
  text: string;
  file_name: string;
  file_size: number;
  status: 'NOUVELLE' | 'LUE' | 'RETENUE';
  status_label: string;
  editor_note: string;
  created_at: string;
  updated_at: string;
}

export interface EditorRecommendation extends Recommendation {
  clinic_name: string;
  clinic_schema: string;
  username: string;
  author_name: string;
  author_email: string;
  author_roles: string;
}

export const MY_KEY = ['recommandation'] as const;
export const EDITOR_KEY = ['editeur', 'recommandations'] as const;

export const ACCEPTED_FILES =
  '.pdf,.doc,.docx,.odt,.txt,.rtf,.xls,.xlsx,.csv,.ppt,.pptx,.png,.jpg,.jpeg';

export function useMyRecommendation(enabled = true) {
  return useQuery({
    queryKey: MY_KEY,
    queryFn: () =>
      apiFetch<{ recommendation: Recommendation | null }>('/recommandation').then(
        (r) => r.recommendation,
      ),
    enabled,
  });
}

export function fileSize(bytes: number): string {
  if (bytes < 1024) return `${bytes} o`;
  if (bytes < 1024 * 1024) return `${Math.round(bytes / 1024)} Ko`;
  return `${(bytes / 1024 / 1024).toFixed(1).replace('.', ',')} Mo`;
}

export const STATUS_COLOR: Record<Recommendation['status'], string> = {
  NOUVELLE: 'blue',
  LUE: 'gray',
  RETENUE: 'teal',
};

export function useEditorRecommendations(params: { q?: string; status?: string } = {}) {
  return useQuery({
    queryKey: [...EDITOR_KEY, params],
    queryFn: () => apiFetch<EditorRecommendation[]>('/editeur/recommandations', { query: params }),
  });
}

/** Nombre de recommandations nouvelles (tableau de bord de l'éditeur). */
export function useNewRecommendationCount(): number | undefined {
  return useEditorRecommendations({ status: 'NOUVELLE' }).data?.length;
}
